import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SPEER_ORGANIZATION_SCHEMA } from 'core/utilities';

/** Site-wide Schema.org Organization JSON-LD (homepage, /about, and all routes). */
export const OrganizationSchema: React.FunctionComponent = () => (
    <Helmet>
        <script type="application/ld+json">{JSON.stringify(SPEER_ORGANIZATION_SCHEMA)}</script>
    </Helmet>
);
